import { create } from 'zustand';

import { Subscription, SubscriptionTypes } from 'src/dashboard/settings/billing';
import { Nullable } from 'src/types/nullable.type';

interface State {
  currentSubscription: any;
  subscriptionPlanType: Nullable<SubscriptionTypes>;
  customMsg: string | undefined | null;
  customHeader: string | undefined | null;
  feature: string | undefined | null;
  subscriptionLoading: boolean;
  isStarter: boolean;
  isPro: boolean;
  isEnterprise: boolean;
  isSubscribed: boolean;
  isOnTrial: boolean;
  trialStartAt: string | null;
  trialEndAt: string | null;
  trialExpired: boolean;
  daysLeftInTrial: number;
  openPricingPaywall: boolean;
  setCurrentSubscription: (Subscription: Subscription) => void;
  setOpenPricingPaywall: (pricingToggle: boolean) => void;
  setCustomMsg: (msg: string | null) => void;
  setCustomHeader: (msg: string | null) => void;
  setFeature: (feature: string | null) => void;
}

export const useCurrentSubscription = create<State>((set: any, get: any) => ({
  currentSubscription: null,
  subscriptionLoading: true,
  subscriptionPlanType: null,
  customHeader: null,
  customMsg: null,
  feature: null,
  isStarter: false,
  isPro: false,
  isEnterprise: false,
  isSubscribed: false,
  isOnTrial: false,
  trialStartAt: null,
  trialEndAt: null,
  trialExpired: false,
  daysLeftInTrial: 0,
  openPricingPaywall: false,
  setOpenPricingPaywall: (pricingToggle: boolean) => {
    set({ openPricingPaywall: pricingToggle });
  },
  setCustomMsg: (msg: string | null) => {
    set({ customMsg: msg });
  },
  setCustomHeader: (msg: string | null) => {
    set({ customHeader: msg });
  },
  setFeature: (feature: string | null) => {
    set({ feature: feature });
  },
  setCurrentSubscription: (subscription: Subscription) => {

    // Calculate days left in trial if trial data exists
    let daysLeftInTrial = 0;
    if (subscription?.trial_end_at && !subscription?.trial_expired) {
      const trialEnd = new Date(subscription.trial_end_at);
      const today = new Date();
      const diffTime = trialEnd.getTime() - today.getTime();
      daysLeftInTrial = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      daysLeftInTrial = Math.max(0, daysLeftInTrial);
    }
    
    // Map plan types to new pricing structure
    // starter -> starter (Start plan)
    // pro -> pro (Grow plan) 
    // enterprise -> enterprise (Scale plan)
    const planType = subscription?.plan_type;
    
    const isOnTrial = subscription?.status === 'trialing' && subscription?.trial_start_at && !subscription?.trial_expired;

    set({ 
        currentSubscription: subscription,
        subscriptionPlanType: planType ?? 'pro', // Default to 'pro' for trial
        isStarter: planType === 'starter',
        isPro: (planType === 'pro') || isOnTrial,
        isEnterprise: planType === 'enterprise',
        isSubscribed: subscription?.status === 'active', 
        isOnTrial: isOnTrial,
        trialStartAt: subscription?.trial_start_at || null,
        trialEndAt: subscription?.trial_end_at || null,
        trialExpired: subscription?.trial_expired || false,
        daysLeftInTrial,
        subscriptionLoading: false
    });

    // console.log(
    //   subscription,
    //   planType ?? 'pro', // Default to 'pro' for trial
    //   planType === 'starter',
    //   planType === 'pro' || (subscription?.trial_start_at && !subscription?.trial_expired),
    //   planType === 'enterprise',
    //   subscription?.status === 'active', 
    //   subscription?.status === 'trialing' || (subscription?.trial_start_at && !subscription?.trial_expired),
    //   subscription?.trial_start_at || null,
    //   subscription?.trial_end_at || null,
    //  subscription?.trial_expired || false,
    //   daysLeftInTrial,
    //   false
    // )
  },
}));
